import { Stack, Text } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { BucketInfo } from 'src/stores/BucketStatsStore';
import { useStores } from 'src/utils/hooks/useStores';
import { StatusFolderButton } from './StatusFolderButton';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

export const FilterStatusFolders = observer(() => {
  const { t } = useTranslations(translations);
  const {
    jobApplicationStore: { bucketStatsStore },
  } = useStores();

  const statusFolderButtonsList = bucketStatsStore?.bucketInfo
    ?.map((bucketInfo: BucketInfo) => (
      <StatusFolderButton key={bucketInfo.type} bucketInfo={bucketInfo} />
    ))
    .filter((statusFolderButton) => statusFolderButton !== undefined);

  return (
    <Stack space="medium">
      <Text size="xsmall" tone="secondary" weight="medium">
        {t('Status')}
      </Text>
      <Stack space="none">{statusFolderButtonsList}</Stack>
    </Stack>
  );
});
